import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CreateProductPage } from './create-product.page';
import { SharedModule } from './../../shared-module/shared.module';
import { CreateProductPageRoutingModule } from './create-product-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    SharedModule,
    CommonModule,
    CreateProductPageRoutingModule
  ],
  declarations: [CreateProductPage]
})
export class CreateProductPageModule {}
